import { createReducer, on } from "@ngrx/store";
import * as EmployeeActions from "./employee-actions";
import { EmployeeStateInterface } from "src/app/company/models/employeeStateInterface";

export const initialState: EmployeeStateInterface = {
    isLoading: false,
    employees: [],
    htecEmployees:[],
    error: null,
};

export const employeeReducers = createReducer(
    initialState, 

    // get Employees
    on(EmployeeActions.getEmployees, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(EmployeeActions.getEmployeesSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        employees: action.employees.slice().sort((a, b) => a.firstName.localeCompare(b.firstName))
    })),
    on(EmployeeActions.getEmployeesFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // get HTEC Employees
    on(EmployeeActions.getHtecEmployees, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(EmployeeActions.getHtecEmployeesSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        htecEmployees: action.htecEmployees.slice().sort((a, b) => a.firstName.localeCompare(b.firstName))
    })),
    on(EmployeeActions.getHtecEmployeesFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // create Employee 
    on(EmployeeActions.createEmployee, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(EmployeeActions.createEmployeeSuccess, (state, action) => ({
        ...state, 
        isLoading: false,
        employees: [...state.employees, action.employee].sort((a, b) => a.firstName.localeCompare(b.firstName
        ))
    })),
    on(EmployeeActions.createEmployeeFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // update Employee
    on(EmployeeActions.updateEmployee, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(EmployeeActions.updateEmployeeSuccess, (state, action) => {
        const updatedIndex = state.employees.findIndex(employee => employee.id === action.employee.id);
        
        if (updatedIndex === -1) {
            return state; // If employee not found, return current state
        }

        const updated = [...state.employees];
        updated[updatedIndex] = action.employee;

        return {
            ...state,
            isLoading: false,
            employees: updated.sort((a, b) => a.firstName.localeCompare(b.firstName))
        };
    }),
    on(EmployeeActions.updateEmployeeFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // delete Employee
    on(EmployeeActions.deleteEmployee, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(EmployeeActions.deleteEmployeeSuccess, (state,action) => ({
        ...state, 
        isLoading: false,
        employees: state.employees.filter(employee => employee.id !== action.id)
      })),
    on(EmployeeActions.deleteEmployeeFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),
);